import { fetchSuppliersRoutine } from 'modules/suppliers/ducks/actions'

const defaultState = {
  list: [],
  currentSaleOrder: {},
  pagination: null,
  isLoading: false
}

const suppliersReducer = (state = defaultState, action) => {
  switch (action.type) {
    case fetchSuppliersRoutine.TRIGGER:
      return {
        ...state,
        isLoading: true
      }
    case fetchSuppliersRoutine.FAILURE:
      return {
        ...state,
        isLoading: false
      }
    case fetchSuppliersRoutine.SUCCESS:
      return {
        ...state,
        list: action.payload.data,
        pagination: {
          itemsCount: action.payload.meta.total,
          totalPages: action.payload.meta.lastPage,
          perPage: action.payload.meta.perPage,
          currentPage: action.payload.meta.currentPage
        },
        isLoading: false
      }
    default:
      return state
  }
}

export default suppliersReducer
